import React, {useState, useEffect} from "react";

const LandscapePopup = ({setShowPopup, heading, text, btnText, onClick, imageSrc  }) => {
   
  const closePopup = () =>{
      console.log("Close icon clicked");
      setShowPopup(false);
  }

    return (
      <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="w-[360px] flex flex-col justify-center items-center relative rounded-[23px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[20px] shadow-lg">
          <div className="absolute top-2 right-2">
            <img
              className="absolute right-3 top-[6px] cursor-pointer"
              src={require("./Assets/Cross.svg").default}
              alt=""
              onClick={closePopup}
            />
          </div>

        {imageSrc && (
          <img
            src={imageSrc}
            alt="popup visual"
            className="mb-2 mt-[-60px]"
          />
        )}
          <h2
            className="mt-[-30px] mb-[5px] text-center text-[16px]"
          >
             {heading}
          </h2>
          <p className="text-center text-[14px] w-[320px]">{text}</p>
          <div className="w-full flex flex-col justify-center items-center gap-[10px] mt-[30px]">
            <button
                className="w-full h-[40px] rounded-[5px] bg-[#B5AAFF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={() => window.location.reload()}>
                {btnText}
            </button>
            <p className="text-[14px] text-[#4C34AD] cursor-pointer" onClick={closePopup}>Back</p>
          </div>
        </div>
      </div>
    );
  };

export default LandscapePopup;
